import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ParkingLotWithExt } from "@onsip/web/features/administrators/parkingLot/parkingLotPage/parking-lot-page.component";

@Component({
  selector: "onsip-caller-settings-view",
  templateUrl: "./caller-settings-view.component.html",
  styleUrls: ["../../parkingLotShelfContainer/parking-lot-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CallerSettingsViewComponent {
  @Input() parkLot!: ParkingLotWithExt;
  @Output() editPanel = new EventEmitter<void>();
  constructor() {}
}
